import { DOCUMENT, inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { jwtTokenGetter } from './services/jwt';

/** API hosts that get the login token, besides the app's own host. Add a new environment's host here. */
export const API_HOSTS = ['localhost:5001', 'zilex.nikama.net', 'zilex.de', 'dev-zilex.nikama.net', 'app.zilex.de'];

const STANDARD_PORTS = ['80', '443'];

/**
 * Adds "Authorization: Bearer <token>" to requests for the app's own host and the API_HOSTS, when logged in
 * (replaces @auth0/angular-jwt's JwtInterceptor; same rules). An expired token is sent too — the API answers 401.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const location = inject(DOCUMENT).location;
  const url = new URL(req.url, location.origin);
  const host = url.hostname + (url.port && !STANDARD_PORTS.includes(url.port) ? ':' + url.port : '');
  const token = jwtTokenGetter();

  if (!token || (url.host !== location.host && !API_HOSTS.includes(host))) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
